import Image from 'components/LegacyImage'

export const CarouselImage = (props: {
  src: string
  className: string
  width: number
  height: number
}) => (
  <Image {...props} alt='' priority objectFit='cover' objectPosition='center' />
)
